import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Card, Alert } from "react-bootstrap";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { getCookie, checkCookie } from "../../Utils/Utils";
import {  resonateExclusiveList,  setOrderList } from "../../../redux/action";
import { ENABLE_RESONATE_WEBSITE, ORDER_API, PRODUCTS_API } from "../../../constants/Constants";
import Header from "../../Content/Header/Header";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core";

import axios from "axios";
import Categories from "../../Content/Categories/Categories";
require("./ResonateExclusive.scss");

class ResonateExclusive extends Component {
  componentDidMount() {
    if (!checkCookie("emailId")|| !ENABLE_RESONATE_WEBSITE) {
      this.setState({ redirect: true });
    } else {
      this.getUserDetails(getCookie("emailId"));
      if (this.props.resonateExclusive.length === 0) {
        axios
          .get(PRODUCTS_API + "/type/" + this.state.pageName.toLowerCase())
          .then(response => {
            this.handleResonateExclusiveList(response.data.products);
          });
      }
    }
  }

  handleResonateExclusiveList(products) {
    this.props.resonateExclusiveList(products);
  }

  getUserDetails(email) {
    if (this.props.orders === undefined) {
      axios.get(ORDER_API + "?userId=" + getCookie("userId")).then(response => {
        this.props.setOrderList(response.data.orderList);
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      cookie: false,
      pageName: "resonate-exclusives",
      resonateExclusive: []
    };

    this.handleLike = this.handleLike.bind(this);
  }

  handleLike(productId) {
    axios.put(PRODUCTS_API + "/like/" + productId).then(response => {
      axios
        .get(PRODUCTS_API + "/type/" + this.state.pageName.toLowerCase())
        .then(response => {
          this.handleResonateExclusiveList(response.data.products);
        });
    });
  }

  render() {
    const resonateExclusive = this.props.resonateExclusive;
    return (
      <Container className="page-container">
        <Header />
        <Categories />
        <Alert className="alert-message" key="primary" variant="primary">
          The items listed below are available in person on May 3<sup>rd</sup>{" "}
          at Resonate.
        </Alert>
        <Container className="resonate-exclusives-container">
          {Object.keys(resonateExclusive).map(key => (
            <Card className="resonate-exclusives-card" key={key}>
              <Card.Img className="resonate-exclusives-image" src={resonateExclusive[key].imageName} />
              <Card.Body className="resonate-exclusives-card-body">
                <Accordion>
                  <AccordionSummary className="resonate-exclusives-title">
                    {resonateExclusive[key].productName} <ExpandMoreIcon />
                  </AccordionSummary>
                  <AccordionDetails className="resonate-exclusives-description">
                    {resonateExclusive[key].description}
                  </AccordionDetails>
                </Accordion>                
              </Card.Body>
            </Card>
          ))}
        </Container>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    resonateExclusive: state ? state.filterResonateExclusive : [],
    user: state ? state.user : null,
    orders: state ? state.orders : []
  };
};

const mapDispatchToProps = dispatch => {
  return {
    resonateExclusiveList: resonateExclusive => {
      dispatch(resonateExclusiveList(resonateExclusive));
    },
    setOrderList: orders => {
      dispatch(setOrderList(orders));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  pure: false
})(ResonateExclusive);
